import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { confirmToolAction } from "../../services/assistantService";

const TOOL_LABELS = {
  createAppointment: "Crear cita",
  rescheduleAppointment: "Reagendar cita",
  blockDayUnavailable: "Bloquear disponibilidad",
};

const COLORS = {
  surface: "#232a33",
  border: "rgba(255,255,255,0.08)",
  textPrimary: "#edeff2",
  textSecondary: "#8d99a8",
  accent: "#2f8fff",
  danger: "#ff6b6b",
};

export default function AssistantToolConfirmCard({ toolName, args, jwt, onConfirmed, onCancel }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await confirmToolAction({ toolName, args, jwt });
      onConfirmed(result);
    } catch (err) {
      console.error("Assistant tool confirmation error:", err);
      setError(err.message || "No se pudo confirmar la acción.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      style={{
        margin: "4px 0",
        backgroundColor: COLORS.surface,
        border: `1px solid ${COLORS.border}`,
        boxShadow: "none",
      }}
    >
      <CardContent>
        <div style={{ color: COLORS.textPrimary, fontSize: 14, fontWeight: 600, marginBottom: 6 }}>
          {TOOL_LABELS[toolName] || toolName}
        </div>
        <pre
          style={{
            fontSize: 12,
            whiteSpace: "pre-wrap",
            color: COLORS.textSecondary,
            backgroundColor: "rgba(255,255,255,0.04)",
            border: `1px solid ${COLORS.border}`,
            borderRadius: 8,
            padding: 10,
            margin: "0 0 10px",
          }}
        >
          {JSON.stringify(args, null, 2)}
        </pre>
        {error && (
          <div style={{ color: COLORS.danger, fontSize: 12, marginBottom: 8 }}>{error}</div>
        )}
        <div style={{ display: "flex", gap: 8 }}>
          <Button
            onClick={handleConfirm}
            disabled={loading}
            variant="contained"
            style={{ backgroundColor: COLORS.accent, color: "#fff", boxShadow: "none" }}
          >
            {loading ? <CircularProgress size={16} style={{ color: "#fff" }} /> : "Confirmar"}
          </Button>
          <Button onClick={onCancel} disabled={loading} style={{ color: COLORS.textSecondary }}>
            Cancelar
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
